export var PRIMARY_FONT = 'TondoCorp-Regular';
export var PRIMARY_BOLD_FONT = 'TondoCorp-Bold';